import 'css-chunk:../vue-router/index.module.scss';export default {
  "router": "_router_zqh1v_1"
};